inits.push("Tasks.init()");


window.Tasks = {
    /**
     * Parameter Kürzel und Ausgeschrieben
     * In der Dropdownliste sind die Kürzel als data-Attribut
     */
    aParameter : {
        'A': 'Abfluss',
        'GZ': 'Gesamtzufluss',
        'L': 'Lufttemperatur',
        'N': 'Niederschlag',
        'SF': 'Speicherfüllstand',
        'SI': 'Speicherinhalt',
        'W': 'Wasserstand',
        'WT': 'Wassertemperatur'
    },
    dlgDelete : {},
    init: function () {
        // Abbruch wenn keine Tasks auf der Seite vorhanden sind
        if ($('.hvd-tasks').length === 0) return;

        // Dialog löschen
        Tasks.dlgDelete = $('#dlg-taskDelete').dialog({
            open: function(event,ui) {

            },
            buttons: [{
                text: "Abbrechen",
                class: "cancel",
                click: function () {
                    $(this).dialog("close");
                }
            }, {
                text: 'Löschen',
                class: 'ok',
                click: function() {
                    console.debug('lösche:' + Tasks.dlgDelete.taskId );
                    $.ajax({
                        type: 'POST',
                        url: '/Handler/HvD/Task',
                        data: {
                            data: { action: 'del', id: Tasks.dlgDelete.taskId }
                        }
                    }).done(function (data) {
                        if (data === 'ok') {
                            tools.toast('Aufgaben', 'Die Aufgabe wurde gelöscht');
                            $('#worker').show();
                            location.reload();
                        } else if (data === 'edit') {
                            tools.toast('Aufgaben', 'Fehler beim Löschen');
                        }
                    });
                }
            }],
            autoOpen: false,
            height: 200,
            width: 300,
            modal: false
        })
        $('.task-delete').on('click',function(event) {
            var $task = $(this).parents('.task-edit');
            Tasks.dlgDelete.find('.task-name').html($task.find('.task-name').html());
            Tasks.dlgDelete.taskId = $(this).attr('data-id');
            Tasks.dlgDelete.dialog('open');
        });
        // Wiedervorlage DateTimePicker setzen
        $('.hvd-tasks .resubmit').each(function(i) {
            var resubmit = $(this);
            var x = resubmit.datetimepicker({
                changeMonth: true,
                changeYear: true,
                dateFormat: 'dd.mm.yy',
                timeFormat: "HH:mm",
                defaultDate: resubmit.val()
            });
            resubmit.datepicker("option", $.datepicker.regional['de']);
            // Startwert setzen
            resubmit.val(resubmit.attr('data-value'));
        });

        /**
         * Parameter abhängig von der Station auswählbar machen
         */
        $('.task-selectstation-dropdown').each(function (event) {
            var $item = $(this);
            $item.param = $('#taskParam_' + $item.attr('data-index'));
            Tasks.setParameterList($item).selectmenu({
                width: '100%'
            });

            $item.selectmenu({
                width: '100%',
                change: function (event, ui) {
                    Tasks.setParameterList($(this)).selectmenu('refresh');
                }
            });
        });
        $('.task-intervall-dropdown').selectmenu({
            width: '100%'
        });


        $('.task-add').on('click', function (event) {
            if (!$(this).parents('.bar').find('i.toggle').hasClass('icon-down-circle')) {
                $(this).parents('.bar').find('i.toggle').click();
            }
            $('.task-new').animate({
                height: 'toggle'
            }, 200);
            return false;
        });

        document.querySelectorAll('.hvd-tasks input.task-intervall').forEach( /** @param {HTMLInputElement} el */ function(el) {
            el.addEventListener('change', function() {
                el.closest('.row').querySelector('.intervall-body').classList.toggle('hide');
                el.closest('.task-item').querySelector('.non-intervall-body').classList.toggle('hide');

            });
        });
        /**
         * Task anlegen/speichern
         */
        $('.hvd-tasks button.ok').on('click', function (event) {
            // Formulardaten ermitteln
            var $fields = $(this).parents('.task-edit').find('input, select, .ckedit');

            $fields.each(function(index,el) {
                if (el.type === 'checkbox' ) {
                    el.value = el.checked?'1':'0';
                }
            });
            var $frmData = {};
            $fields.each(function (i) {
                if (this.name === undefined) {
                    $frmData[$(this).attr('data-name')] = $(this).html();
                } else {
                    $frmData[this.name] = $(this).val();
                    if (this.name === 'stationId') {
                        // StationsTyp ist im options @data-type
                        $frmData['stationType'] = $(this).find('option:selected').attr('data-type');
                    }
                }
            })
            $.ajax({
                type: 'POST',
                url: '/Handler/HvD/Task',
                data: {
                    data: $frmData
                }
            }).done(function (data) {
                if (data === 'ok') {
                    tools.toast('Aufgaben', 'Die Aufgabe wurde angelegt');
                    $('#worker').show();
                    location.reload();
                } else if (data === 'edit') {
                    tools.toast('Aufgaben', 'Die Aufgabe wurde gespeichert');
                }
            });
        });
    },
    setParameterList: function ($item) {
        var aParams = $item.find('option:selected').attr('data-parameter').split(';');
        var sCurrentParam = $('#taskParam_' + $item.attr('data-index')).val(); // $item.param.val();
        var $drpParameters = $item.parents('.task-item').find('.task-selectparameter-dropdown');
        $drpParameters.html('');
        if (aParams.length === 1 && aParams[0] === '') {
            $drpParameters.append('<option value="0" selected>-- Keine Parameter vorhanden --</option>');
            return $drpParameters;
        }
        for (var i = 0; i < aParams.length; i++) {
            var selected = '';
            if (sCurrentParam === aParams[i]) {
                selected = ' selected';
            }
            $drpParameters.append('<option value="' + aParams[i] + '"' + selected + '>' + Tasks.aParameter[aParams[i]] + '</option>');
        }
        return $drpParameters;
    }
}
